import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components"
import Header from "./Header"
import healthymeal from "./images/healthymeal.jpg";
import healthyman from "./images/coupledance.png";
import balance from "./images/balance.jpg";
import protein from "./images/protein.jpg"
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import danielle2 from "../src/images/danielle2.png"
import annie2 from "../src/images/annie2.png"
import celine2 from "../src/images/celine2.png"
import christine1 from "../src/images/christine1.png"
import guideFR from "../src/files/Devient-Une-Machine.pdf"
import guideEN from "../src/files/BurnFatNaturally-Guide.pdf";
import CookieConsent from "./CookieConsent";
import healthyquiz from "../src/images/healthyquiz.jpg"

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const Homepage = () => {
  const { t , i18n } = useTranslation();
  const navigate = useNavigate()
  const [stories, setStories] = useState([]);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [coaches, setCoaches] = useState([]);
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const coachImages = {
    annie2: annie2,
    danielle2: danielle2,
    celine2: celine2,
    christine2: christine1
  };

    useEffect(() => {
       const fetchStories = async () => {
         try {
             const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
           const response = await fetch(`${API_URL}getSuccessStories`);
           const data = await response.json();
   
           const localizedStories = data.map(story => ({
             ...story,
             quote: story.quote[i18n.language] || story.quote.en,
             summary: story.summary[i18n.language] || story.summary.en,
           }));
   
           setStories(localizedStories);
         } catch (error) {
           console.error("Failed to fetch success stories:", error);
         }
       };
   
       fetchStories();
     }, [i18n.language]);

     useEffect(() => {
            const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
          
            fetch(`${API_URL}reps`)
              .then((res) => res.json())
              .then((data) => {
                setCoaches(data);
              })
              .catch((error) => {
                console.error("Error fetching reps!", error);
              });
          }, []);


      if (stories.length === 0) {
    return (
      <Story>
        <Header />
        <p style={{ textAlign: "center", marginTop: "50px" }}>{t('success.Loading')}</p>
        <Footer />
      </Story>
    );
  }
   
     const handleNext = () => {
       setCurrentStoryIndex((prevIndex) => (prevIndex + 1) % stories.length);
     };
   
     const handlePrev = () => {
       setCurrentStoryIndex((prevIndex) => (prevIndex - 1 + stories.length) % stories.length);
     };
    

  const { name, lost, images, quote, summary } = stories[currentStoryIndex];

    

          const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
          };
          
          const handleSubmit = async (e) => {
            e.preventDefault();
            setIsSubmitting(true);
            try {
              const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000/'}send-free-guide`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
              });
          
              if (res.ok) {
                const currentLang = i18n.language;
                const fileToDownload = currentLang === 'fr' ? guideFR : guideEN;
                const link = document.createElement('a');
                link.href = fileToDownload;
                link.download = currentLang === 'fr'
                  ? 'Devient-Une-Machine.pdf'
                  : 'BurnFatNaturally-Guide.pdf';
                document.body.appendChild(link);
                setTimeout(() => {
                  link.click();
                  document.body.removeChild(link);
                }, 100);
          
                setFormData({ name: '', email: '' });
              } 
            } catch (err) {
              console.error("Submission error:", err);
            } finally {
              setIsSubmitting(false);
            }
          };
  return (
    <div>
    <Header/>
    <Homebody>
    <CookieConsent />
    <Imageflex>
  <ImageCard onClick={() => navigate("/shop")}>
    <Imagebox src={healthymeal} alt="Healthy Meal" />
    <OverlayText>{t('home.saladLink')}</OverlayText>
  </ImageCard>

  <ImageCard onClick={() => navigate("/success")}>
    <Imagebox src={healthyman} alt="Healthy Man" />
    <OverlayText>{t('home.manLink')}</OverlayText>
  </ImageCard>

  <ImageCard onClick={() => navigate("/consultation")}>
    <Imagebox src={balance} alt="Balance" />
    <OverlayText>{t('home.balanceLink')}</OverlayText>
  </ImageCard>
</Imageflex>



          <Quote>{t('home.quote')}</Quote>
          <SwirlyLine xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150">
        <path d="M-40,50 C150,0 250,100 500,50 S850,150 1000,-60" fill="transparent" stroke="green" strokeWidth="2"/>
      </SwirlyLine>

      <QuizSection>
  <QuizBackground>
    <QuizContent>
      <QuizQuote>{t('home.quizquote1')}</QuizQuote>
      <QuizQuote>{t('home.quizquote2')}</QuizQuote>
      <QuizButton onClick={() => {
    const quizLink =
      i18n.language === "en"
        ? "https://form.typeform.com/to/ZJiP6m9T" // English version
        : "https://form.typeform.com/to/sTQgxDPm"; // French version
    window.open(quizLink, "_blank");
  }}
>
  {i18n.language === "en" ? "Start →" : "Débuter →"}
</QuizButton>
    </QuizContent>
  </QuizBackground>
</QuizSection>
      <Sectiontwo>
        <Sectwobkg src={protein} alt="Meal" />
        <TextInSection>
          <TextTitle>{t('home.sectionTitle')}</TextTitle>
          <SecTwoTxt>{t('home.sectionContent')}</SecTwoTxt>  
          <SecTwoTxt>{t('home.sectionContentTwo')}</SecTwoTxt>
          <SecTwoTxt>{t('home.sectionContentThree')}</SecTwoTxt>
          <SecTwoTxt>{t('home.sectionContentFour')}</SecTwoTxt>   
          <Freeconsult onClick={() => navigate("/consultation")}>{t('home.balanceLink')}</Freeconsult>   
        </TextInSection>
      </Sectiontwo>
      <SwirlyLine xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150">
        <path
          d="M-40,50 C150,0 250,100 500,50 S850,150 1000,-60"
          fill="transparent"
          stroke="green"
          strokeWidth="2"
        />
      </SwirlyLine>

      <TitleSuc>{t('success.Success')}</TitleSuc>
        <StyledContainer>
        <SideButton onClick={handlePrev}>{t('success.Previous')}</SideButton>
       <Story>
          <Rightbox>
            <PersonInfo>
              <Name>{name}</Name>
              <Divider />
              <Lost>{t('success.Lost')} {lost} {t('success.Pounds')}</Lost>
            </PersonInfo>
            <ImageRow>
              <Polaroid rotate="-8deg">
                <P>
                  <IMG src={images[0]} alt={`${name} first`} />
                </P>
              </Polaroid>
              <Polaroid rotate="8deg">
                <P>
                  <IMG src={images[1]} alt={`${name} second`} />
                </P>
              </Polaroid>
            </ImageRow>
            <ButtonWrapper>
              <p>{t('success.Inspired')}</p>
              <button>{t('success.Start')}</button>
            </ButtonWrapper>
          </Rightbox>
          <DivQuoteMid>
            <Quotediv>
              <p>{quote}</p>
            </Quotediv>
            <UnderPics>
              <p>{summary}</p>
            </UnderPics>
          </DivQuoteMid>
        </Story>
        <SideButton onClick={handleNext}>{t('success.Next')}</SideButton>
      </StyledContainer>
  <CenteredButtonWrapper>
    <a href="/success">
      <SuccessButton  onClick={() => navigate("/success")}>{t("home.viewSucc")}</SuccessButton>
    </a>
  </CenteredButtonWrapper>
  <SwirlyLine xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150">
        <path d="M-40,50 C150,0 250,100 500,50 S850,150 1000,-60" fill="transparent" stroke="green" strokeWidth="2"/>
      </SwirlyLine>
  <TitleSuc>{t('home.coach')}</TitleSuc>
  <CoachGrid>
        {coaches
        .filter(coach => coach.firstName !== "Véronique")
        .map((coach, index) => (
          <CoachPolaroid key={coach._id} rotate={index % 2 === 0 ? "-2deg" : "2deg"}>
            <img src={coachImages[coach.image2]} alt={coach.firstName} />
            <h3>{coach.firstName} {coach.lastName}</h3>
            <p>{coach.title[i18n.language] || ""}</p>
            <button onClick={() => {navigate(`/consultation?coach=${encodeURIComponent(coach.firstName + " " + coach.lastName)}`)}}>{t('home.book')} {coach.firstName}</button>
          </CoachPolaroid>
        ))}
      </CoachGrid>
      <CenteredButtonWrapper>
      <SuccessButton  onClick={() => navigate("/coach")}>{t('home.coachinfo')}</SuccessButton>
    </CenteredButtonWrapper>
    <SwirlyLine xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150">
        <path d="M-40,50 C150,0 250,100 500,50 S850,150 1000,-60" fill="transparent" stroke="green" strokeWidth="2"/>
      </SwirlyLine>
    <SectionDownload>
    <Title>{t("home.downloadTitle")}</Title>
    <Paragraph>{t("home.readyTo")} </Paragraph>
    <Paragraph>{t("home.listIntro")}</Paragraph>
    <BulletList>
      <li>{t("home.listItem1")}</li>
      <li>{t("home.listItem2")}</li>
      <li>{t("home.listItem3")}</li>
      <li>{t("home.listItem4")}</li>
      <li>{t("home.listItem5")}</li>
    </BulletList>
  <form onSubmit={handleSubmit}>
  <FormInput type="text" name="name" placeholder={t("home.fullName")} value={formData.name} onChange={handleChange} required/>
  <br/>
  <FormInput type="email" name="email" placeholder={t("home.email")} value={formData.email} onChange={handleChange} required/>
  <br/>
  <DownloadButton type="submit" disabled={isSubmitting}>
    {isSubmitting ? t("home.loading") : t("home.downloadBtn")}
  </DownloadButton>
</form>
</SectionDownload>
      
    </Homebody>
    <Footer/>
    </div>
  );
}

export default Homepage;

const Quote = styled.p`
color: white;
font-family: 'Great Vibes', cursive;
text-align: center;
font-size: 50px;
width: 90%;
margin: auto;
margin-top: -30px;
margin-bottom:30px;
`;
const Homebody = styled.div`
background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
padding-bottom:100px;
 font-family: 'Montserrat', sans-serif;
`;
const Imageflex = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 20px;
  padding: 35px 20px;
`;

const ImageCard = styled.div`
  position: relative;
  width: 30%;
  min-width: 280px;
  border-radius: 30px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
`;

const Imagebox = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  filter: brightness(95%);
  transition: filter 0.3s ease;
`;
const OverlayText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  z-index: 2;
  pointer-events: none;
  text-shadow: 1px 2px 10px rgba(0,0,0,0.7);
`;
const SwirlyLine = styled.svg`
  display: block;
  margin: auto;
  margin-top: -70px;
  margin-bottom: -90px;
  height: 200px;
  width: 80%;
  max-width: 850px;
`;
const Sectiontwo = styled.div`
  width: 95%;
  height: fit-content;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 10%, #f7f9fc 30%), url(${protein});
  background-position: center bottom;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  text-align: center;
  box-shadow: 0 8px 24px lightgray;
  margin: auto;
  padding-bottom: 30px;
  margin-bottom:40px;
`;
const Sectwobkg = styled.img`
  display: none;
`;
const TextInSection = styled.div`
  color: black;
  margin-top: 120px;
  font-size: 18px;
  margin-left: 30px;
  margin-right: 30px;
`;
const Freeconsult = styled.button`
padding: 15px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
font-size: 18px;
border-radius: 20px;
margin-bottom: 50px;
cursor: pointer;
&:hover {
  background-color: rgb(218, 145, 127);
    }
`
const TextTitle = styled.p`
font-size: 30px;
font-weight: 600;
text-shadow: 2px 2px white;
`

 /* success */

 const Polaroid = styled.div`
 background-color: white;
 padding-bottom: 40px;
 width: 250px;
 box-shadow: 0px 4px 20px rgba(246, 187, 155, 1);
 text-align: center;
 margin-left: 20px;
 transform: rotate(${(props) => props.rotate || "0deg"});
 transition: transform 0.3s ease;

 &:hover {
   box-shadow: 0px 4px 20px rgba(186, 204, 171, 1);
   transform: rotate(${(props) => props.rotate || "0deg"}) scale(1.3);
 }

 @media (width: 1500px) {
   width: 250px;
   margin-left: 10px;
   transform: none;

   &:hover {
     transform: scale(1.1);
   }
 }
`;
const Name = styled.p`
  margin-bottom: -30px;
  margin-top: -2px;
  font-weight: bolder;
  font-size: 40px;
  text-shadow: 0 2px 12px white;
  font-family: 'Great Vibes', cursive;
`;
const Lost = styled.p`
  margin-top: -2px;
  padding-bottom: 10px;
  font-weight: bold;
  font-style: italic;
  color: rgb(233, 149, 129);
  text-shadow: 0 2px 12px black;
`;
const Quotediv = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65%;
  padding: 40px;
  font-size: 24px;
  text-align: center;
  border-radius: 10px;
  position: relative;
  font-style: italic;
  line-height: 1.5;
  animation: ${fadeIn} 1.5s ease forwards;

  &::before,
  &::after {
    content: '"';
    font-size: 80px;
    color: black;
    position: absolute;
    font-family: serif;
  }

  &::before {
    top: 10px;
    left: 20px;
  }

  &::after {
    bottom: 10px;
    right: 20px;
  }

  p {
    margin: 0;
    max-width: 500px;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4%;

  button {
  padding: 10px;
  background-color: rgba(217,121,97,1);
  color: white;
  border: none;
  box-shadow: 0 4px 24px white;
  font-size: 18px;
  border-radius: 10px;
  margin-bottom: 50px;
  cursor: pointer;

    &:hover {
      background-color: rgb(218, 145, 127);
    }
  }

  p {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;
const DivQuoteMid = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;
  @media (max-width: 1500px) {
    width: 90%;
  }
`;
const UnderPics = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  margin-top: 20px;
  font-size: 20px;
  text-align: center;
`;
const Story = styled.div`
  animation: ${fadeIn} 1s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;
  background: rgba(84, 133, 51, 0.11);
  box-shadow: 0 8px 24px black;
  padding: 40px;
  border-radius: 10px;
  min-height: 650px;
  margin: 0 auto;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px;
  }
`;
const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 2px dashed white;
  margin: 30px 0 10px;
`;
const P = styled.p`
  background-color: white;
`;
const IMG = styled.img`
  width: 90%;
  object-fit: cover;
  max-height: 400px;  /* Prevents images from resizing excessively */
`;
const TitleSuc = styled.div`
  text-align: center;
  font-family: 'Great Vibes', cursive;
  font-size: 60px;
  padding: 10px;
  color: white;
  padding-top: 30px;
  padding-bottom: 30px;
`;
const PersonInfo = styled.div`
  background-color: rgba(186, 204, 171, 0.4);
  border-radius: 10px;
  text-align: center;
  width: 100%;
  font-size: 25px;
  padding-top: 10px;
`;
const CenteredButtonWrapper = styled.div`
  text-align: center;
  margin-top: 40px;
`;
const Rightbox = styled.div`
  border-radius: 10px;
  max-width: 40%;
  min-width: 350px;
  height: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 280px;
    height: auto;
  }
`;
const ImageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
  gap: 10px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
const SuccessButton = styled.button`
padding: 10px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
box-shadow: 0 4px 24px white;
font-size: 18px;
border-radius: 10px;
margin-bottom: 50px;
cursor: pointer;
&:hover {
  background-color: rgb(218, 145, 127);
    }
`
const SideButton = styled.button`
   background-color: rgba(217,121,97,1);
    color: white;
    border: none;
    padding:14px;
    border-radius: 20px;
    font-size: 18px;
    cursor: pointer;

    &:hover {
    background-color: rgb(218, 145, 127);
    transform: scale(1.05);
  }
`;
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 5%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

/* coaches */
const CoachPolaroid = styled.div`
  background-color: white;
  width: 250px;
  box-shadow: 0px 4px 20px rgba(246, 187, 155, 1);
  text-align: center;
  padding: 20px;
  border-radius: 10px;
  transform: rotate(${(props) => props.rotate || "0deg"});
  transition: transform 0.3s ease;

  &:hover {
    box-shadow: 0px 4px 20px rgba(186, 204, 171, 1);
    transform: rotate(${(props) => props.rotate || "0deg"}) scale(1.05);
  }
  img {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    object-fit: cover;
    max-height: 280px;
  }
  h3 {
    font-family: 'Great Vibes', cursive;
    font-size: 38px;
    margin: 10px 0 5px;
  }
  p {
    font-size: 18px;
    color: #444;
  }
  button {
    background-color: rgba(217,121,97,1);
    color: white;
    border: none;
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 18px;
    cursor: pointer;

    &:hover {
      background-color: rgb(218, 145, 127);
    }
  }
`;
const CoachGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 60px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const SectionDownload = styled.section`
  margin-bottom: 60px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 30px;
  border-radius: 20px;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 2px 2px 20px black;
`;
const Paragraph = styled.p`
  font-size: 22px;
  color: black;
  line-height: 1.6;
`;
const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0 40px;

  li {
    font-size: 22px;
    color: black;
    margin-bottom: 12px;
    gap: 10px;
  }
`;
const DownloadButton = styled.button`
display: inline-block;
background-color: rgba(217,121,97,1);
color: white;
padding: 14px 28px;
border-radius: 30px;
font-size: 20px;
text-decoration: none;
transition: all 0.3s ease;
box-shadow: 2px 2px 24px white;
cursor: pointer;
border: none;

&:hover {
  background-color: rgb(218, 145, 127);
  transform: scale(1.05);
}
`;

const FormInput = styled.input`
width: 250px;
height: 30px;
margin-bottom: 10px;
border-radius: 10px;
border: none;

`
const Title = styled.h2`
text-align: center;
font-family: 'Great Vibes', cursive;
  font-size: 55px;
  margin-bottom: 20px;
  color: black;
`;

const SecTwoTxt = styled.p`
font-size: 20px;
`
const QuizSection = styled.section`
  width: 100%;
  position: relative;
  margin-bottom: 40px;
`;

const QuizBackground = styled.div`
  background-image: url(${healthyquiz});
  width: 92%;
  background-repeat: no-repeat;
  filter: brightness(140%);
  background-size: cover;
  transition: filter 0.3s ease;
  height: 250px;
  display: flex;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  text-align: center;
  padding: 80px 20px;
  color: white;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.4);
`;

const QuizContent = styled.div`
  max-width: 800px;
  backdrop-filter: blur(50px); /* more dreamy blur */
  background: rgba(219, 219, 219, 0.3); /* soft pink with transparency */
  border-radius: 20px;
  padding: 20px;
  animation: ${fadeIn} 1s ease-in-out;
`;

const QuizQuote = styled.h2`
  font-size: 1.9rem;
  font-weight: 700;
  color: #fff;
  text-shadow: 
    0 0 10px rgba(0, 0, 0, 0.9),
    0 0 20px rgba(0, 0, 0, 0.7),
    0 0 30px rgba(0, 0, 0, 0.6),
    0 0 40px rgba(0, 0, 0, 0.5);
  margin-bottom: 20px;
  line-height: 1.4;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const QuizButton = styled.button`
  background: rgba(255, 255, 255, 1);
  color: black;
  border: none;
  border-radius: 30px;
  padding: 14px 36px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
  &:hover {
    transform: scale(1.05);
  }
`;
